import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "@/lib/auth";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Trade from "@/pages/Trade";
import Markets from "@/pages/Markets";
import Leaderboard from "@/pages/Leaderboard";
import Profile from "@/pages/Profile";
import Alerts from "@/pages/Alerts";
import Backtest from "@/pages/Backtest";
import StrategyAI from "@/pages/StrategyAI";
import Journal from "@/pages/Journal";
import Report from "@/pages/Report";
import Options from "@/pages/Options";
import Roadmap from "@/pages/Roadmap";
import Bots from "@/pages/Bots";
import Broker from "@/pages/Broker";
import CopyPage from "@/pages/CopyPage";
import Pro from "@/pages/Pro";
import AutoTrade from "@/pages/AutoTrade";
import AiCouncil from "@/pages/AiCouncil";
import Health from "@/pages/Health";
import Ops from "@/pages/Ops";
import Legal from "@/pages/Legal";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/legal" element={
            <div className="max-w-5xl mx-auto px-6 py-10"><Legal /></div>
          } />

          <Route element={<ProtectedRoute />}>
            <Route element={<Layout />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/trade" element={<Trade />} />
              <Route path="/options" element={<Options />} />
              <Route path="/roadmap" element={<Roadmap />} />
              <Route path="/bots" element={<Bots />} />
              <Route path="/markets" element={<Markets />} />
              <Route path="/backtest" element={<Backtest />} />
              <Route path="/strategy-ai" element={<StrategyAI />} />
              <Route path="/journal" element={<Journal />} />
              <Route path="/report" element={<Report />} />
              <Route path="/broker" element={<Broker />} />
              <Route path="/copy" element={<CopyPage />} />
              <Route path="/pro" element={<Pro />} />
              <Route path="/pro/success" element={<Pro />} />
              <Route path="/auto" element={<AutoTrade />} />
              <Route path="/ai-council" element={<AiCouncil />} />
              <Route path="/health" element={<Health />} />
              <Route path="/ops" element={<Ops />} />
              <Route path="/leaderboard" element={<Leaderboard />} />
              <Route path="/profile/:id" element={<Profile />} />
              <Route path="/alerts" element={<Alerts />} />
            </Route>
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
